const data = [
    {
        Name: "Koniec i początek.",
        SourceUri: "../../../assets/videos/haikyuu/1/01.mp4",
        ThumbUri: "../../../assets/images/haikyuu/main.jpg",
        Ep: 1,
        SkipTimeStart: 48,
        SkipTimeEnd: 137,
        NextEpTime: 1362
    },
    {
        Name: "Klub siatkarski Liceum Karasuno.",
        SourceUri: "../../../assets/videos/haikyuu/1/02.mp4",
        ThumbUri: "../../../assets/images/haikyuu/main.jpg",
        Ep: 2,
        SkipTimeStart: 35,
        SkipTimeEnd: 124,
        NextEpTime: 1362
    },
    {
        Name: "Sojusznik budzący grozę.",
        SourceUri: "../../../assets/videos/haikyuu/1/03.mp4",
        ThumbUri: "../../../assets/images/haikyuu/main.jpg",
        Ep: 3,
        SkipTimeStart: 75,
        SkipTimeEnd: 164,
        NextEpTime: 1362
    },
    {
        Name: "Widok z góry.",
        SourceUri: "../../../assets/videos/haikyuu/1/04.mp4",
        ThumbUri: "../../../assets/images/haikyuu/main.jpg",
        Ep: 4,
        SkipTimeStart: 127,
        SkipTimeEnd: 216,
        NextEpTime: 1362
    },
    {
        Name: "Lęk tchórza.",
        SourceUri: "../../../assets/videos/haikyuu/1/05.mp4",
        ThumbUri: "../../../assets/images/haikyuu/main.jpg",
        Ep: 5,
        SkipTimeStart: 54,
        SkipTimeEnd: 143,
        NextEpTime: 1362
    }
]
module.exports = data;